<template>
    <v-dialog v-model="isOpen" persistent width="536px" class="admin-offers-edit">
        <v-card class="admin-offers-edit__card" >
            <v-card-text class="admin-offers-edit__card-title px-0">
                Editar oferta: <br> 
                <span class="admin-offers-edit__card-title--title-item">{{item.title}}</span>
            </v-card-text>
            <v-card-text>
                <v-text-field
                    label="id"
                    :value="item.id"
                    readonly
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Peso"
                    v-model="weight"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Redirección"
                    v-model="redirect"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-select
                    label="Oferta pagada"
                    v-model="tabulated"
                    :items="itemsTabulated"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
            </v-card-text>
            <v-card-actions class="admin-offers-edit__card d-flex justify-end align-center mx-0 px-0">
                <v-btn
                    @click="closeDialog"
                    outlined
                    color="#3BADFF"
                    dark
                    :disabled="isLoading"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    :loading="isLoading"
                    @click="updateItem"
                    outlined
                    color="#3BADFF"
                    dark
                    class="px-5"
                >
                    Editar
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import { datetime, currentImg } from "@/libs/mixins";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "AdminOffersEdit",
    props: {
        item: {
            type: Object
        },
        dialogOffersEdit: {
            default: false,
            type: Boolean
        }
    }, 
    mixins: [datetime, currentImg],
    data() {
        return {
            isLoading: false,
            isOpen: false,
            errors: false,
            weight: 0,
            redirect: "",
            tabulated: false,
            itemsTabulated: [
                { desc: "No Pagada", value: false },
                { desc: "Pagada", value: true }
            ]
        };
    },
    computed: {

    },
    watch: {
        errors() {
            console.info("errors: ", this.errors);
        },
        dialogOffersEdit() {
            this.isOpen = this.dialogOffersEdit || false;
        },
        item() {
            this.weight = this.item.weight;
            this.tabulated = this.item.tabulated;
            this.redirect = this.item && this.item.redirect ? this.item.redirect : "";
        }
    },
    methods: {
        ...mapActions("offers", ["update"]),
        closeDialog() {
            this.isLoading = false;
            this.$emit("close");
        },
        async updateItem() {
            try {
                this.isLoading = true;
                this.item.weight = parseInt(this.weight);
                this.item.redirect = this.redirect;
                this.item.tabulated = this.tabulated;
                const item = {
                    organiationId: this.item.organiationId,
                    offer: {
                        id: this.item.id,
                        weight: this.item.weight,
                        tabulated: this.item.tabulated
                    }
                };
                if (this.redirect !== "") {
                    item.offer.redirect = this.redirect;
                } else {
                    item.offer.redirect = null;
                }
                await this.update(item);
                this.$emit("updateItemsList", this.item);
                this.$emit("close");
                this.isLoading = false;
            } catch (error) {
                console.error(error);
            }
        },
    }
};
</script>
